<template>
  <component :is="isShow"></component>
</template>
<script>
import First from './index1.vue';
import Last from './carStopNengBrand.vue';
import Cookies from "js-cookie";

export default {
  name: 'index',
  components: {First, Last},
  data() {
    return {
      isShow:''
    }
  },
  mounted() {
    if (Cookies.get('userType') == '2'){
      // 市
      this.isShow=Last
    }else{
      this.isShow=First
    }
  },
}
</script>

<style lang="stylus" scoped>

</style>
